<template>
  <div>
    <b-form-invalid-feedback
      class="text-info"
      :force-show="show && !validatePassLength"
    >
      {{ $t('password_helper.pass_size', { count: size_count }) }}
    </b-form-invalid-feedback>
    <b-form-invalid-feedback
      class="text-info"
      :force-show="show && !validatePassDigits"
    >
      {{ $t('password_helper.pass_digit', { count: digit_count }) }}
    </b-form-invalid-feedback>
    <b-form-invalid-feedback
      class="text-info"
      :force-show="show && !validateUppercaseLength"
    >
      {{ $t('password_helper.pass_uppercase', { count: uppercase_count }) }}
    </b-form-invalid-feedback>
    <b-form-invalid-feedback
      class="text-info"
      :force-show="show && !validateLowercaseLength"
    >
      {{ $t('password_helper.pass_lowercase', { count: lowercase_count }) }}
    </b-form-invalid-feedback>
    <b-form-invalid-feedback
      class="text-info"
      :force-show="show && !validateSymbolLength"
    >
      {{ $t('password_helper.pass_symbol', { count: symbol_count }) }}
      ()[]{}|\`~!@#$%^&*_-+=;:'",&lt;&gt;./?"]
    </b-form-invalid-feedback>
    <b-form-invalid-feedback
      class="text-info"
      :force-show="show && !validateConsecutiveCharacters"
    >
      {{ $t('password_helper.pass_repeated', { count: repeated_count }) }}
    </b-form-invalid-feedback>
  </div>
</template>


<script>
const MIN_PASS_LENGTH = 8;
const MIN_PASS_DIGITS = 1;
const MIN_UPPERCASE_COUNT = 1;
const MIN_LOWERCASE_COUNT = 1;
const MIN_SYMBOL_COUNT = 1;
const MAX_REPEATED_CHARACTERS = 3;

export default {
  name: "password-helper",
  props: {
    password: String,
    show: Boolean,
  },
  data() {
    return {
      size_count: String(MIN_PASS_LENGTH),
      digit_count: String(MIN_PASS_DIGITS),
      uppercase_count: String(MIN_UPPERCASE_COUNT),
      lowercase_count: String(MIN_LOWERCASE_COUNT),
      symbol_count: String(MIN_SYMBOL_COUNT),
      repeated_count: String(MAX_REPEATED_CHARACTERS),
    };
  },
  computed: {
    validatePassLength() {
      if (!this.password) {
        return false;
      }
      if (this.password.length >= MIN_PASS_LENGTH) {
        return true;
      }
      return false;
    },
    validatePassDigits() {
      if (!this.password) {
        return false;
      }
      let digits_match = this.password.match(/\d+/gi);
      if (!digits_match) {
        return false;
      }
      if (digits_match.join("").length >= MIN_PASS_DIGITS) {
        return true;
      }
      return false;
    },
    validateUppercaseLength() {
      if (!this.password) {
        return false;
      }
      let uppercase_count = this.password.match(/[A-Z]/g);
      if (!uppercase_count) {
        return false;
      }
      if (uppercase_count.join("").length >= MIN_UPPERCASE_COUNT) {
        return true;
      }
      return false;
    },
    validateLowercaseLength() {
      if (!this.password) {
        return false;
      }
      let lowercase_count = this.password.match(/[a-z]/g);
      if (!lowercase_count) {
        return false;
      }
      if (lowercase_count.join("").length >= MIN_LOWERCASE_COUNT) {
        return true;
      }
      return false;
    },
    validateSymbolLength() {
      if (!this.password) {
        return false;
      }
      let symbol_count = this.password.match(
        /[()[\]{}|\\`~!@#$%^&*_\-+=;:'",<>./?]/g
      );
      if (!symbol_count) {
        return false;
      }
      if (symbol_count.join("").length >= MIN_SYMBOL_COUNT) {
        return true;
      }
      return false;
    },
    validateConsecutiveCharacters() {
      if (!this.password) {
        return false;
      }
      let regex_string =
        "((\\w)\\2{" + String(MAX_REPEATED_CHARACTERS - 1) + ",})";
      let regex = new RegExp(regex_string, "g");
      let consecutive_count = this.password.match(regex);
      if (!consecutive_count) {
        return true;
      }
      return false;
    },
    validatePass() {
      if (!this.validatePassLength) {
        return false;
      }
      if (!this.validatePassDigits) {
        return false;
      }
      if (!this.validateUppercaseLength) {
        return false;
      }
      if (!this.validateLowercaseLength) {
        return false;
      }
      if (!this.validateSymbolLength) {
        return false;
      }
      if (!this.validateConsecutiveCharacters) {
        return false;
      }
      return true;
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        password_helper: {
          pass_size: "Must contain at least {count} characters.",
          pass_digit: "Must contain at least {count} digit.",
          pass_uppercase: "Must contain at least {count} uppercase letter.",
          pass_lowercase: "Must contain at least {count} lowercase letter.",
          pass_symbol: "Must contain at least {count} symbol.",
          pass_repeated:
            "Must not contain {count} repeated characters (Example: aaa)",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.text-info {
  color: red !important;
}
</style>
